import { render, staticRenderFns } from "./CorporationCard.vue?vue&type=template&id=92e51724&"
import script from "./CorporationCard.vue?vue&type=script&lang=js&"
export * from "./CorporationCard.vue?vue&type=script&lang=js&"
import style0 from "./CorporationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports